import React, { useCallback } from 'react';
import useRequestJSON from '../../libs/hooks/useRequestJSON';
import { AppsResponse, AppsData, AppsValue, AppsMapping } from './types';
import { PostJSON } from '../../libs/request';
import { createAppsData } from './utils';

export interface IApp {
  name: string;
  key: string;
}

interface AppsProviderProps {
  isAdminPortal?: boolean;
}

const AppsContext = React.createContext<AppsValue>({
  data: null,
  isLoading: true,
  error: null,
  getAppByPhone: null,
  getAppName: null
});

const transform = (response: AppsResponse): AppsData => {
  return createAppsData(response);
};

export const AppsProvider: React.FC<AppsProviderProps> = (props) => {
  const isAdminPortal = props.isAdminPortal ?? false;
  const request = useCallback(
    () =>
      PostJSON<AppsResponse>({
        url: isAdminPortal ? '/data_apps/' : '/applications/'
      }),
    []
  );
  const { data, isLoading, error } = useRequestJSON<AppsResponse, AppsData>({
    request,
    transformFn: transform
  });

  const getAppByPhone = (phone: string) => {
    if (!data) {
      return;
    }
    if (!phone || !phone.length) {
      return;
    }
    const app = Object.entries(data.apps).find((entry) => {
      const app = entry[1];
      return app.twilio === phone;
    });
    if (!app) {
      return;
    }
    return app[1];
  };

  const value: AppsValue = {
    data,
    isLoading,
    error,
    getAppByPhone,
    getAppName: (key) => (data && data.apps[key] ? data.apps[key].name : '')
  };

  return <AppsContext.Provider value={value} {...props} />;
};

export function useApps(): AppsValue {
  const context = React.useContext(AppsContext);
  if (context === undefined) {
    throw new Error('useApps must be used within a AppsProvider');
  }
  return context;
}

export type { AppsMapping };
